import { render, staticRenderFns } from "./ShippingCompanies.vue?vue&type=template&id=458b807e&"
import script from "./ShippingCompanies.vue?vue&type=script&lang=ts&"
export * from "./ShippingCompanies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports